<script>
  export let props = {};
</script>

<style style="text/scss" lang="scss">
  .questions-tab {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .question {
      font-weight: 500;
      color: #000;
      text-align: left;
      cursor: pointer;
      padding: 6px 8px;
      margin-left: -8px;
      border-radius: 4px;
      width: calc(100% + 16px);
      transition: 200ms;

      &:hover {
        background: #f1f1f1;
      }
    }
  }
</style>

<div class="questions-tab">
  {#each props.questions as question}
    <div
      class="question"
      on:click={() => {
        props.onQuestionSelect(question);
      }}>
      {question.value}
    </div>
  {/each}
</div>
